import React, { useState } from "react";
import ApproveDisputeModal from "./ApproveDisputeModal";
import { useAppSelector } from "../../../redux/app/hooks";
import moment from "moment";

interface AppealModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const AppealModal: React.FC<AppealModalProps> = ({ isOpen, onClose }) => {
  const [isFinalDescisionModalOpen, setOpenFinalDecisionModal] =
    useState(false);
  const { selectedDispute } = useAppSelector((state) => state.orders);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-2xl p-6">
        {/* Modal Header */}
        <div className="flex justify-between items-center mb-4 ">
          <h2 className="text-xl font-semibold">Appeal Message</h2>
          <button
            onClick={onClose}
            className="text-black hover:text-gray-800 text-lg"
          >
            &times;
          </button>
        </div>
        <div className="border-b  mb-4"></div>
        {/* Modal Body */}
        <div className="space-y-4">
          {/* Sender and Date */}
          <div className="flex justify-between">
            <p className="text-gray-600">
              {selectedDispute?.order?.contract?.vendorId?.fullName} to Intasida
              Technologies
            </p>
            <p className="text-gray-600">
              {moment(selectedDispute?.appealDate).format("Do MMM YYYY")}
            </p>
          </div>

          {/* Subject */}
          <div className="flex items-center gap-4">
            <span className="text-gray-600">Subject:</span>
            <span className="font-medium">
              Appeal against {selectedDispute?.reviewDefaulter.toLowerCase()}'s dispute
            </span>
          </div>

          <div className="border-b  mb-4"></div>

          {/* Message Body */}
          <div className="text-gray-700">
            <p>Dear Intasida Technologies,</p>
            <p className="mt-2">{selectedDispute?.appeal}</p>
            {/* <p className="mt-2">
              I am submitting an appeal regarding the dispute raised by the
              buyer for a purchase with Contract ID{" "}
              <span className="font-medium">INT212345</span>. I strongly believe
              the claim is unfair, and I would like to provide additional
              evidence to support my case.
            </p>
            <p className="mt-2">
              The buyer claims that the item was defective, but I personally
              inspected and packaged it before displaying. The product was in
              perfect condition before it was handed over to the Courier agent.
            </p>
            <p className="mt-2">
              To support my appeal, I have attached some evidence below.
            </p>
            <p className="mt-2">
              I kindly request a review of this dispute before any decision is
              made. Please let me know if any further information is required.
            </p>
            <p className="mt-4">Best regards,</p>
            <p className="font-medium">Bells Otterbevo</p>
            <p className="text-gray-600">Bells Shores</p>
            <p className="text-gray-600">bellsshore@gmail.com</p> */}
          </div>

          {/* Attachments
          <div className="mt-4">
            <p className="text-gray-600">Attachments:</p>
            <div className="flex space-x-4 mt-2 flex-col">
              <div className="bg-gray-100 p-2 rounded-lg">
                <p className="text-sm">Screwman_M05232.bg</p>
                <p className="text-xs text-gray-500">754kb</p>
              </div>
              <div className="bg-gray-100 p-2 rounded-lg">
                <p className="text-sm">Screwman_M05232.bg</p>
                <p className="text-xs text-gray-500">754kb</p>
              </div>
            </div>
          </div> */}
        </div>
        {/* Modal Footer */}
        <div className="mt-6 flex justify-end space-x-4">
          <button
            onClick={onClose}
            className="bg-gray-100 text-gray-800 px-4 py-2 rounded-lg hover:bg-gray-200"
          >
            Close
          </button>
          <button
            onClick={() => setOpenFinalDecisionModal(true)}
            className="bg-primary text-white px-4 py-2 rounded-full text-sm font-medium hover:bg-indigo-700"
          >
            Take Final Decision
          </button>
        </div>
      </div>

      <ApproveDisputeModal
        isOpen={isFinalDescisionModalOpen}
        onClose={() => setOpenFinalDecisionModal(false)}
        modalTitle="Dispute final decision"
      />
    </div>
  );
};

export default AppealModal;
